import axios from 'axios'

const baseUrl = '/api/v2/me'

export default class Users {
  /**
   * @param {*} callback
   */
  static retrieveInformations (callback) {
    axios.get(`${baseUrl}`).then(response => callback(response))
  }

  /**
   * @param {*} callback
   */
  static retrieveCompanies (callback) {
    axios.get(`${baseUrl}/companies?addresses=true`).then(response => callback(response))
  }

  /**
   * @param {*} callback
   */
  static retrieveSettings (callback) {
    axios.get(`${baseUrl}/settings/last-agency/2`).then(response => callback(response))
  }
}
